import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { SettingsFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { BankBalanceSettingsFormContainerProps } from "models/propTypes/settingsPropTypes";
//#endregion
//#region components
import BankBalanceSettingsForm from "./bankBalanceSettingsForm";
import { Skeletons, useMountedState } from "components/common";
import { useBankBalanceService } from "serviceHooks";
//#endregion
import * as Yup from "yup";

const BankBalanceSettingsFormContainer: ForwardRefRenderFunction<FormHandles, BankBalanceSettingsFormContainerProps> = (
  props,
  ref
) => {
  const bankBalanceService = useBankBalanceService();
  const { getMounted } = useMountedState();
  const [loading, setLoading] = React.useState<boolean>(true);
  const [accounts, setAccounts] = React.useState<SettingsFormTypes.BankBalanceAccountSetting[]>([]);
  const [loadFailed, setLoadFailed] = React.useState<boolean>(false);

  React.useEffect(() => {
    bankBalanceService
      .getVisibilitySettings()
      .then((res) => {
        if (getMounted()) {
          setAccounts(
            (res ?? []).map((balance) => ({
              accountId: balance.accountId,
              accountNumber: balance.accountNumber,
              bankName: balance.bankName,
              bankAccountNumber: balance.bankAccountNumber,
              showOnDashboard: balance.showOnDashboard,
            }))
          );
        }
      })
      .catch(() => {
        if (getMounted()) {
          setLoadFailed(true);
        }
      })
      .finally(() => {
        if (getMounted()) {
          setLoading(false);
        }
      });
  }, []);

  const validationSchema = Yup.object<SettingsFormTypes.BankBalanceSettings>({
    accounts: Yup.array().of(
      Yup.object<SettingsFormTypes.BankBalanceAccountSetting>({
        accountId: Yup.number().required(),
        showOnDashboard: Yup.boolean().required(),
      })
    ),
  });

  const handleSubmit = (values: SettingsFormTypes.BankBalanceSettings) =>
    bankBalanceService.updateVisibilitySettings(
      values.accounts.map((account) => ({
        accountId: account.accountId,
        showOnDashboard: account.showOnDashboard,
      }))
    );

  return loading ? (
    <Skeletons.FormSkeleton />
  ) : (
    <BankBalanceSettingsForm
      defaultValues={{ accounts }}
      loadFailed={loadFailed}
      validationSchema={validationSchema}
      handleSubmit={handleSubmit}
      ref={ref}
      {...props}
    />
  );
};

export default forwardRef(BankBalanceSettingsFormContainer);
